import React from 'react';
import { Spinner } from 'react-bootstrap';
import { ServicesContext } from '~/services';
import { Form, FormGroup, ValidationMessage } from '~/components/Form';

interface EditInfoProps {
    edit: () => void;
}
export function EditInfo({ edit }: EditInfoProps) {
    const servicesContext = React.useContext(ServicesContext);
    const [currentp, setCurrentp] = React.useState('');
    const [pword, setPword] = React.useState('');
    const [confirmpword, setConfirmpword] = React.useState('');
    const [validation, setValidation] = React.useState(false);
    const [responseMessage, setResponseMessage] = React.useState(false);
    const [saving, setSaving] = React.useState(false);

    async function handleSubmit() {
        try {
            setSaving(true);
            await servicesContext.user.update(
                {
                    current_password: currentp,
                    password: pword,
                    confirmation_password: confirmpword,
                },
                { handledErrors: true }
            );
            setSaving(false);
            edit();
            servicesContext.alert.set('Password successfully updated', 'success');
        } catch (e) {
            setSaving(false);
            setValidation(true);
            setResponseMessage(e.response);
        }
    }

    return (
        <Form onSubmit={handleSubmit} values={{ currentp, pword, confirmpword }} autoComplete="off">
            <FormGroup htmlFor="currentp" className="mb-3 row">
                <label htmlFor="currentp" className="col-4 text-end col-form-label">
                    Current Password
                </label>
                <div className="col-8">
                    <input
                        type="password"
                        required
                        className="form-control"
                        id="currentp"
                        value={currentp}
                        onChange={(e) => setCurrentp(e.target.value)}
                    />
                </div>
                <ValidationMessage type="required" className="offset-4 col-8">
                    Current Password is required.
                </ValidationMessage>
                <ValidationMessage
                    type="external"
                    rule={validation}
                    className="offset-4 col-12 col-sm-7 col-lg-8"
                >
                    {Array.isArray(responseMessage) &&
                        responseMessage
                            .filter((x) => x.propertyPath === 'current_password')
                            .map((x) => <div key={x.message}>{x.message}</div>)}
                </ValidationMessage>
            </FormGroup>
            <FormGroup htmlFor="pword" className="mb-3 row">
                <label htmlFor="pword" className="col-4 text-end col-form-label">
                    New Password
                </label>
                <div className="col-8">
                    <input
                        type="password"
                        required
                        className="form-control"
                        id="pword"
                        value={pword}
                        onChange={(e) => setPword(e.target.value)}
                    />
                </div>
                <ValidationMessage type="required" className="offset-4 col-8">
                    Password is required.
                </ValidationMessage>
                <ValidationMessage
                    type="external"
                    rule={validation}
                    className="offset-4 col-12 col-sm-7 col-lg-8"
                >
                    {Array.isArray(responseMessage)
                        ? responseMessage
                              .filter((x) => x.propertyPath !== 'current_password')
                              .map((x) => <div key={x.message}>{x.message}</div>)
                        : responseMessage}
                </ValidationMessage>
            </FormGroup>
            <FormGroup htmlFor="confirmpword" className="mb-3 row">
                <label htmlFor="confirmpword" className="col-4 text-end col-form-label">
                    Confirm Password
                </label>
                <div className="col-8">
                    <input
                        type="password"
                        required
                        data-match="pword"
                        className="form-control"
                        id="confirmpword"
                        value={confirmpword}
                        onChange={(e) => setConfirmpword(e.target.value)}
                    />
                </div>
                <ValidationMessage type="required" className="offset-4 col-8">
                    Password confirmation is required.
                </ValidationMessage>
                <ValidationMessage type="match" className="offset-4 col-8">
                    Passwords must match.
                </ValidationMessage>
            </FormGroup>
            <div className="row">
                <div className="col-12 text-end">
                    <button
                        className="btn btn-secondary me-2"
                        type="button"
                        onClick={edit}
                        disabled={saving}
                    >
                        Cancel
                    </button>
                    <button className="btn btn-primary" type="submit" disabled={saving}>
                        {saving && (
                            <Spinner
                                animation="border"
                                variant="light"
                                size="sm"
                                role="status"
                                className="me-1"
                            />
                        )}
                        Save
                    </button>
                </div>
            </div>
        </Form>
    );
}
